export const RECEIVE_PURCHASE_ORDERS = "RECEIVE_PURCHASE_ORDERS";
export const RECEIVE_TRADE_DOCUMENTS = "RECEIVE_TRADE_DOCUMENTS";
export const CREATE_PURCHASE_ORDERS = "CREATE_PURCHASE_ORDERS";
export const REMOVE_PURCHASE_ORDERS = "REMOVE_PURCHASE_ORDERS";
export const FILTER_PURCHASE_ORDERS = "FILTER_PURCHASE_ORDERS";

export const TRADE_DOCUMENTS_FETCH_BEGIN   = 'FETCH_PURCHASE_ORDERS_BEGIN';
export const TRADE_DOCUMENTS_FETCH_SUCCESS = 'FETCH_PURCHASE_ORDERS_SUCCESS';
export const TRADE_DOCUMENTS_FETCH_FAILURE = 'FETCH_PURCHASE_ORDERS_FAILURE';
export const TRADE_DOCUMENTS_FILTER = 'TRADE_DOCUMENTS_FILTER';

// Fix on phase7
export const RECEIVE_USER_TRADE_DOCUMENT = "RECEIVE_USER_TRADE_DOCUMENT";
export const RESET_TRADE_DOCUMENTS = "RESET_TRADE_DOCUMENTS"



// WEBPACK FOOTER //
// ./src/features/trade_documents/actionTypes.js